var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.39404 2H41.0001","stroke":"#355E02","strokeWidth":"4","strokeLinecap":"round","id":"top-line","key":0}),React.createElement("path",{"d":"M2 10H40.6061","stroke":"#355E02","strokeWidth":"4","strokeLinecap":"round","id":"middle-line","key":1}),React.createElement("path",{"d":"M2 18H40.6061","stroke":"#355E02","strokeWidth":"4","strokeLinecap":"round","id":"bottom-line","key":2})]);
}

HamburgerMenu.defaultProps = {"width":"43","height":"20","viewBox":"0 0 43 20","fill":"none"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
